import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import EventTypes from "../shared/EventTypes";

export default class Menu extends AbstractProvidedClass {
    config = {
        'select': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#cursor-fill"></use></svg>',
            'tooltip': 'Select (C)',
            'callback': () => this.tools.setTool('select'),
        },
        'shapes': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#shape-line"></use></svg>',
            'tooltip': 'Shapes (A)',
            'callback': () => this.tools.setTool('shapes'),
        },
        'navigation': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#drag-move-2-fill"></use></svg>',
            'tooltip': 'Navigate (N)',
            'callback': () => this.tools.setTool('navigate'),
        },
        'erase': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#eraser-line"></use></svg>',
            'tooltip': 'Eraser (E)',
            'callback': () => this.tools.setTool('erase'),
        },
        'image': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#image-2-line"></use></svg>',
            'tooltip': 'Image (SHIFT + I)',
            'callback': () => this.tools.setTool('image'),
        },
        'settings': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#list-settings-fill"></use></svg>',
            'tooltip': 'Settings (,)',
            'callback': () => this.tools.setTool('settings'),
        },
        'help': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#question-line"></use></svg>',
            'tooltip': 'Help (H)',
            'callback': () => this.tools.setTool('help'),
        },
        'reset': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#refresh-line"></use></svg>',
            'tooltip': 'Reset view (SHIFT+R)',
            'callback': () => this.view.reset(),
        },
        'save': {
            'icon': 'Save',
            'tooltip': 'Save (CTRL+S)',
            'callback': () => this.dataHandler.savePlan(),
        },
        'undo': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#arrow-go-back-fill"></use></svg>',
            'tooltip': 'Undo (CTRL+Z)',
            'callback': () => this.actions.undo(),
        },
        'redo': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#arrow-go-forward-fill"></use></svg>',
            'tooltip': 'Redo (CTRL+Y)',
            'callback': () => this.actions.redo(),
        },
    };

    init(leftButtons, rightButtons) {
        this.container = this.p.createDiv()
            .parent('#p5canvas')
            .class("planner-toolbar")
            .style('z-index', 2);

        this.leftButtons = leftButtons.map((button) => this.createMenuButton(button));
        this.rightButtons = rightButtons.map((button) => this.createMenuButton(button));

        this.on(EventTypes.OPEN_SIDEBAR, () => this.hide());
        this.on(EventTypes.CLOSE_SIDEBAR, () => this.show());
    }

    createMenuButton(name) {
        let config = this.config[name];
        let buttonName = `${name}Button`;
        let button = this.p.createButton(config['icon'])
            .parent(this.container)
            .class('btn-icon-clear -u-tt-bottom')
            .mousePressed(config['callback']);

        if (!this.touch) {
            button.attribute('data-tooltip', config['tooltip']);
        }
        if (['undo', 'redo'].includes(name)) {
            button.attribute('disabled', 'true');
        }
        window[buttonName] = button;
        return button;
    }

    setCurrentToolIcon(_html) {}

    resetCurrentToolIcon() {}

    showNewPlanSaveButton() {}

    showMultiSelectButton(_onToggle) {}

    hideMultiSelectButton() {}

    hide() {
        if (this.container.elt.offsetWidth + this.sideBar.width + this.sideBar.labelWidth + 20 > this.p.width) {
            this.container.hide();
        }
    }

    show() {
        this.container.show();
        this.container.style('display', null);
    }
}
